// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ffc16837","38":"a5d03fa3","167":"9198c4c0","262":"519b11ac","379":"734030fe","453":"1cc10d3c","540":"9695d211","554":"2ef84ea9","578":"9c4880a2","839":"dc53bb99"}[chunkId] + ".chunk.js";
};